
import {
    FaDroplet, FaHeartPulse, FaLungs, FaMagnifyingGlassChart,
    FaUsers,
    FaUserShield,
    FaGaugeHigh,
} from "react-icons/fa6";

export const featuresCardData = [
    {
        icon: <FaHeartPulse />,
        title: "TBL-ABI (Tissue Blood Level and Ankle-Brachial Index)",
        description:
            "This test measures blood flow and pressure in the arms and legs. It detects peripheral arterial disease, revealing blood vessel issues and blockages. This aids doctors in assessing circulation problems.",
    },
    {
        icon: <FaDroplet />,
        title: "SWEAT-C (Sweat Conductance Test)",
        description:
            "Testing sweat glands can reveal the health of the autonomic nervous system. It often spots nerve damage related to diabetes. This test checks gland function and offers insights into involuntary body control.",
    },
    {
        icon: <FaLungs />,
        title: "OXI-W (Oximeter-Waveform Analysis)",
        description:
            "Blood oxygen monitors check vascular health and blood flow. They spot risks for heart and insulin problems. These tools also measure oxygen levels, showing circulatory health and disease risks.",
    },
];

export const stepper = [
    {
        icon: <FaMagnifyingGlassChart />,
        title: "Early Nerve & Vascular Detection",
        description:
            "Detect autonomic neuropathy and vascular issues early with advanced Flow 7 testing.",
        align: "bottom",
    },
    {
        icon: <FaUsers />,
        title: "Coordinated Physician Care",
        description:
            "Share test results between specialists and primary care providers for coordinated patient care.",
        align: "top",
    },
    {
        icon: <FaUserShield />,
        title: "Secure Patient Access",
        description:
            "Give patients secure online access to health records and Flow 7 test results.",
        align: "bottom",
        featured: true,
    },
    {
        icon: <FaGaugeHigh />,
        title: "Fast & Accurate Testing",
        description:
            "Get reliable autonomic and vascular testing results quickly with the integrated Flow 7 System.",
        align: "top",
    },
];